/**
 *
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * http://146.56.218.109:18086/wechat/index.html
 *
 * Copyright 2024-2031 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 */

// 倒计时
function getRandomNum(min, max) {
  return Math.floor(Math.random() * (max - min)) + min;
}

let endTimeG;

function cutDownTime() {
  let nowTime = new Date();
  let endTime = new Date(endTimeG);

  let leftTime = endTime.getTime() - nowTime.getTime();
  if (leftTime < 0) {
    setupNewCountdown();
    leftTime = 0;
  }
  let leftH = Math.floor((leftTime / (1000 * 60 * 60)) % 24),
    leftM = Math.floor((leftTime / (1000 * 60)) % 60),
    leftS = Math.floor((leftTime / 1000) % 60);
  leftH = leftH >= 10 ? leftH : "0" + leftH;
  leftM = leftM >= 10 ? leftM : "0" + leftM;
  leftS = leftS >= 10 ? leftS : "0" + leftS;

  return {
    hour: leftH,
    minute: leftM,
    second: leftS,
  };
}
function setupNewCountdown() {
  const randomHour = getRandomNum(1, 9);
  const currentTime = new Date();
  endTimeG = currentTime.setHours(currentTime.getHours() + randomHour);
}
let intervalId;

function getCutDownTime() {
  setupNewCountdown();
  if (intervalId) clearInterval(intervalId);
  intervalId = setInterval(function () {
    let cutDownTimeText = cutDownTime();
    $(".sp_top_cut_down .sp_left_view .sp_hour").html(cutDownTimeText.hour);
    $(".sp_top_cut_down .sp_left_view .sp_minute").html(cutDownTimeText.minute);
    $(".sp_top_cut_down .sp_left_view .sp_second").html(cutDownTimeText.second);
  }, 1000);
}

getCutDownTime();

new Swiper(".sp-swiper2", {
  autoplay: true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },

  slidesPerView: 1,
  spaceBetween: 0,
  centeredSlides: true,
  // loop: true,
  scrollbar: {
    el: ".swiper-scrollbar",
    draggable: true,
  },
});

let swiper = new Swiper("#swiper-p1", {
  speed: 1,
  on: {
    slideChange: function (e) {
      $("#sp-color .option")
        .eq(e.activeIndex)
        .addClass("active")
        .siblings()
        .removeClass("active");
    },
  },
  spaceBetween: 20,
});
let swiper2 = new Swiper("#swiper-p2", {
  speed: 1,
  on: {
    slideChange: function (e) {
      $("#sp-color2 .option")
        .eq(e.activeIndex)
        .addClass("active")
        .siblings()
        .removeClass("active");
    },
  },
  spaceBetween: 20,
});

let spImgList = [
  "https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20240907-p1.png",
  "https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20240907-p2.png",
  "https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20240907-p3.png",
  "https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20240907-p4.png",
];
let spBannerList = [
  "https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20240907-b1.png",
  "https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20240907-b2.png",
  "https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20240907-b3.png",
  "https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20240907-b4.png",
];

function mainRender() {
  $(function () {
    $("#root").css("zoom", "normal");
    let scale = document.body.clientWidth / 1080;
    $("#root").css("zoom", scale);

    window.addEventListener(
      "resize",
      (function () {
        var timer;
        return function () {
          if (timer) clearTimeout(timer);
          timer = setTimeout(function () {
            $("#root").css("zoom", "normal");
            let scale = document.body.clientWidth / 1080;
            $("#root").css("zoom", scale);
          }, 100);
        };
      })()
    );
  });

  function lazyLoadImages() {
    // 懒加载
    const images = document.querySelectorAll(".lazy-load"); // 获取所有需要懒加载的图片
    const config = {
      rootMargin: "0px 0px 1300px 0px",
      threshold: 0,
    };

    const lazyLoadObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // 当图片进入视口时
          const image = entry.target;
          const dataSrc = image.getAttribute("data-src");
          image.src = dataSrc; // 将data-src属性的值设置为图片的实际地址
          lazyLoadObserver.unobserve(image); // 停止观察该图片
        }
      });
    },
    config);

    images.forEach(function (image) {
      lazyLoadObserver.observe(image); // 开始观察每个图片
    });
  }

  function preloadImages(imageArray) {
    // 预加载
    // 检查数组数据结构
    if (Array.isArray(imageArray[0])) {
      // 处理二维数组
      imageArray.forEach((subArray) => {
        subArray.forEach((url) => {
          const img = new Image();
          img.src = url;
        });
      });
    } else {
      // 处理一维数组
      imageArray.forEach((url) => {
        const img = new Image();
        img.src = url;
      });
    }
  }

  document.addEventListener("DOMContentLoaded", function () {
    lazyLoadImages();

    preloadImages(spImgList);
    preloadImages(spBannerList);

    // 找到所有跳转套餐的锚点链接
    var links = document.querySelectorAll('a[href^="#shopping"]');
    links.forEach(function (link) {
      link.addEventListener("click", function (event) {
        event.preventDefault(); // 阻止默认的跳转行为
        // var targetElement = document.getElementById('shopping');
        // if (targetElement) {
        //     targetElement.scrollIntoView({ behavior: 'smooth' });
        // } // 方式一
        const targetElement = document.getElementById("shopping"); // 获取跳转目标节点
        const offsetTop = targetElement.offsetTop;
        window.scroll({
          top:
            offsetTop * $("div#root").css("zoom") -
            275 * $("div#root").css("zoom"),
          behavior: "smooth", // 使用 smooth 实现平滑滚动
        }); // 方式二
      });
    });
  });

  // IOS字体多了间距的处理 给节点添加 sp_system 类名
  // 判断当前用户是安卓端还是iOS端
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var isAndroid = /android/i.test(userAgent);
  var isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  var isPC = !isAndroid && !isIOS && !/Iron/.test(userAgent); // 添加了对 "Iron" 关键词的判断

  if (isAndroid) {
    console.log("Android");
  } else if (isIOS) {
    console.log("iOS");
  } else if (isPC) {
    console.log("PC");
  } else {
    $(".sp_system").css("letter-spacing", "-4px");
  }
}

mainRender();

jQuery(".sp-scroll").slide({
  mainCell: ".nav-imgs",
  autoPlay: true,
  effect: "leftMarquee",
  interTime: 12,
  vis: 3,
  scroll: 2,
});
// 环形字体
$("#sp_rotate3").arctext({
  radius: 200,
});
$("#sp_rotate4").arctext({
  radius: 200,
});
$("#sp_rotate1").arctext({
  radius: 200,
});
$("#sp_rotate2").arctext({
  radius: 180,
});

// function showTip() {
//   let result = $("#sp_price1").html();

//   if (result >= 50) {
//     $("#freeBtn").addClass("sp-free-btn");
//   } else {
//     $("#freeBtn").removeClass("sp-free-btn");
//   }
// }
let prods = window.product
    function getCur() {
      let color = $('#color div.active').attr('data-val')
      let size1 = $('#Size div.active').attr('data-val')
      return prods.filter(
        item =>
          item.option1 == color &&
          item.option2 == size1
      )[0]
    }
    function changePrice() {
      let num = $('#calcNumber').val()
      let price = ((getCur().price * num) / 100).toFixed(2)
      let compare = ((getCur().compare_at_price * num) / 100).toFixed(2)

      $('#new').html(price)
      $('#old').html(compare)
      let off_font =
        100 - Math.ceil((getCur().price / getCur().compare_at_price) * 100)
      $('.product-part .sp-frees span em').html(`${off_font}`)
    }
    $('.sp-btn-style').click(function () {
      let num = $('#calcNumber').val()
      window.location.href = '/cart/' + getCur().id + ':' + num
    })
    // 数字框
    $('.reduce').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) - 1
      if (num > 0) {
        input.value = num
      }
      changePrice()
    })
    $('.add').click(function () {
      let input = $(this).siblings('input')[0]
      let num = Number(input.value) + 1
      input.value = num
      changePrice()
    })

$(function () {
   let imgArr = [
      'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20251216-pro1-1.png',
      'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20251216-pro1-2.png',
      'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20251216-pro1-3.png',
      'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20251216-pro1-4.png',
      'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20251216-pro2-1.png',
      'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20251216-pro2-2.png',
      'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20251216-pro2-3.png',
      'https://cdn.shopify.com/s/files/1/0805/0550/4031/files/20251216-pro2-4.png',
    ]
    window.cartCount > 0 && $('.sp-cart .num').css('background', '#cf0101')
    let textArr = ['Silver', 'Brown','Deep Gray','Black']
    $('#color .option').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      let index1 = $('#color .active').index()
      let index2 = $('#Size .active').index()
      let index = index1 + index2*4
      $('.sp-pro-imgs img').attr('src', imgArr[index])
      $('.size-choose3').html(textArr[index])
      changeOption()
    })
    $('#Size .option').click(function () {
      $(this).addClass('active').siblings().removeClass('active')
      let index1 = $('#color .active').index()
      let index2 = $('#Size .active').index()
      let index = index1 + index2*4
      $('.sp-pro-imgs img').attr('src', imgArr[index])
      var text = $(this).text()
      $('.size-choose').html(text)
      changeOption()
    })
    function changeOption() {
      changePrice()
    }
    // style选项
    $('.cart-btn').click(function () {
      $(this).children('img').addClass('on')
      setTimeout(function () {
        $('.cart-btn').children('img').removeClass('on')
      }, 500)
      $('.sp-header-top .sp-cart').addClass('on')
      setTimeout(function () {
        $('.sp-header-top .sp-cart').removeClass('on')
      }, 500)
    })
    // 加入购物车
    addCart()
    function addCart() {
      // 加入购物车
      $('.addCerts').click(function () {
        var data = {
          id: getCur().id,
          quantity: $('#calcNumber').val(),
        }
        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          success: function () {
            $.getJSON(
              window.Shopify.routes.root + 'cart.js',
              function (result) {
                $('#cardNum').html(result.item_count)
                $('.sp-cart .num').css('background', '#cf0101')
              }
            )
          },
          dataType: 'json',
        })

        var img = $('.top-product img')
        var flyer = img[0].cloneNode(true)
        flyer.classList.add('clone')
        $('.product-part').append(flyer)
        $('.clone').css({
          width: img.width(),
          height: img.height(),
          position: 'fixed',
          top: img[0].offsetTop,
          left: img.offset().left,
          'z-index': '99',
        })
        var offset = $('.sp-cart')[0].getBoundingClientRect()
        $('.sp-cart').addClass('shake')
        setTimeout(() => {
          $('.sp-cart').removeClass('shake')
        }, 1000)
        let finish = $('.sp-cart')
        $('.clone').animate(
          {
            top: finish[0].offsetTop + 117,
            left: finish[0].offsetLeft + finish.width() / 2 - 15,
            width: 50, // 结束时的大小，根据需要调整
            height: 50, // 结束时的大小，根据需要调整
            opacity: 0.4,
          },
          1000,
          'linear',
          function () {
            $(this).animate(
              {
                width: 0,
                height: 0,
                opacity: 0,
              },
              0,
              function () {
                $(this).detach() // 完成动画后移除克隆的图片
              }
            )
          }
        )
      })
    }
});
